import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput";
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker";

class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            valor: 0,
            uvt_id: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    setData(data) {
        this.setState({
            valor: data.valor,
            uvt_id: data.uvt_id,
        })
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.presupuesto.coeficientesgc.delete}
                postUrl={api.proyectos.config.presupuesto.coeficientesgc.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                missingIdMessage={"Debe seleccionar una fila."}
                successMessage={"El Coeficiente GC ha sido eliminado con éxito."}
                title={"Eliminar Coeficiente GC"}
                buttonTitle={"Eliminar Coeficiente GC"}
                buttonIcon={"fa fa-trash fa-lg"}

                saveButton={true}
                closeButton={true}
                saveButtonLabel={"Eliminar"}
                buttonClass={"btn-danger"}
                danger={true}
                className={"ui-modal-dialog ui-modal-md"}
                onGotData={(data) => this.setData(data)}

            >
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Coeficiente seleccionado</p>
                        <div className="ui-alert ui-alert-danger">
                            <i className="ti ti-trash" aria-hidden="true"></i>
                            <span>Esta acción eliminará el coeficiente GC seleccionado.</span>
                        </div>
                        <ParadigmaLabeledInput label="UVT" labelColumns={12} fieldColumns={12}
                            inputComponent={<ParadigmaAsyncSeeker disabled fieldName={"uvt_id"} url={api.proyectos.config.presupuesto.uvt.select}
                                onChange={(e) => this.setState({ uvt_id: e.pk })} value={this.state.uvt_id} />}
                        />
                        <ParadigmaLabeledInput disabled fieldName="nombre" label="Nombre" labelColumns={12} fieldColumns={12} />
                        <ParadigmaLabeledInput disabled type={"number"} fieldName="valor" label="Valor" labelColumns={12} fieldColumns={12} />
                        <ParadigmaLabeledInput disabled type={"textarea"} fieldName="descripcion" label="Descripción" labelColumns={12} fieldColumns={12} />
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_CoeficientesGC/Delete.js